import { Divider, Grid, Typography } from "@mui/material";
import RowContent from "./RowContent";
import { FormBuilderProps } from "../../utils/interfaces";
import KenColors from "../../utils/kenColors";

export const FormBuilder: React.FunctionComponent<FormBuilderProps> = (props) => {
  const { formJson } = props;
  
  // Debug logging
  console.log('FormBuilder - Received formJson:', formJson);

  return formJson.map((items) => {
    return (
      <>
        <Grid item xs={items.grid.xs} sm={items.grid.sm}  md={items.grid.md} lg={items.grid.lg}>
          <Grid container spacing={3} width={"100%"}>
            {items.rows.map((rows) => {
              return (
                <>
                  {rows?.title && (
                    <>
                      <Typography component={"span"} margin={"15px"} fontWeight={"500"} fontSize={"20px"} textAlign={"start"}>
                        {rows.title.heading}
                      </Typography>
                    </>
                  )}
                  <Grid item xs={rows.grid.xs} md={rows.grid.md} lg={rows.grid.lg}>
                    {rows.fields.map((fields) => {
                      // Debug logging for time range fields
                      if (fields.type === 'timeRange') {
                        console.log('FormBuilder - Time range field found in rows:', {
                          fieldName: fields.name,
                          fieldType: fields.type,
                          rowTitle: rows?.title?.heading
                        });
                      }
                      return <RowContent fields={fields} />;
                    })}
                  </Grid>
                </>
              );
            })}
          </Grid>
        </Grid>
        {items.divider && <Divider style={{ padding: "0px 30px 0px 0px", color: `${KenColors.ClientBlue4} !important` }} orientation="vertical" flexItem />}
      </>
    );
  });
};
